import { useLayoutEffect, useRef, useState } from 'react';
import { Body1, Button } from '@fluentui/react-components';

// Long descriptions start collapsed to a few lines, so the details around them stay in view.
const ExpandableDescription = ({ description }: { description?: string }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  useLayoutEffect(() => {
    const text = textRef.current;
    if (!text || isExpanded) return;
    // Clamped lines make the content taller than its box. A width change rewraps the text, so measure again.
    const measure = () => setIsClamped(text.scrollHeight > text.clientHeight);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(text);
    return () => observer.disconnect();
  }, [description, isExpanded]);
  return (
    <div className="flex flex-col gap-1">
      <div ref={textRef} className={isExpanded ? undefined : 'line-clamp-4'}>
        <Body1 className="!whitespace-pre-wrap break-words">{description || 'No description added.'}</Body1>
      </div>
      {isClamped && (
        <Button className="self-start" appearance="transparent" size="small" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </div>
  );
};
export default ExpandableDescription;
